import { render, staticRenderFns } from "./DictionarySelectPI.vue?vue&type=template&id=6d22b5f7&scoped=true&"
import script from "./DictionarySelectPI.vue?vue&type=script&lang=js&"
export * from "./DictionarySelectPI.vue?vue&type=script&lang=js&"
import style0 from "./DictionarySelectPI.vue?vue&type=style&index=0&id=6d22b5f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22b5f7",
  null
  
)

export default component.exports